<template>
    <div>
        <div class="main">
            <div class="form-row-parse" v-show="!addContract">
                <div class="form-input-parse">
                    <label for="region-input">Регион</label>
                    <select id="region-input" v-model="idRegion" @change="getDistricts">
                        <option
                            v-for="(region, key) in regions"
                            :value="region.ID"
                            :key="key"
                            >
                            {{ region.NAME }}
                        </option>
                    </select>
                </div>
                <div class="form-input-parse" v-show="idRegion">
                    <label for="district-input">Район</label>
                    <select
                        id="district-input"
                        v-model="idDistrict"
                        @change="getVillages"
                        >
                        <option
                            v-for="(district, key) in districts"
                            :value="district.ID"
                            :key="key"
                            >
                            {{ district.NAME }}
                        </option>
                    </select>
                </div>
                <div
                    class="form-input-parse"
                    v-show="idDistrict"
                    @change="changeVillage"
                    >
                    <label for="name-input">Поселок</label>
                    <select id="name-input" v-model="idVillage">
                        <option
                            v-for="(village, key) in villages"
                            :value="village.ID"
                            :key="key"
                            >
                            {{ village.NAME }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="form-row-parse">
                <div class="form-input-parse">
                    <button @click="downloadTemplateContracts">Выгрузить договоры</button>
                    <popup-button button-text="Выгрузить лица">
                        <div class="main">
                            <div class="form-row">
                                <div class="form-field" v-for="(plant, key) in plantsData" :key="key">
                                    <label>Количество лиц для участка #{{plant.NUMBER}} (ID{{plant.ID}})<input v-model="plant.number_of_fields"></label>
                                </div>
                                <div class="form-field">
                                    <button @click="downloadTemplateFaces">Выгрузить</button>
                                </div>
                            </div>
                        </div>
                    </popup-button>
                </div>
            </div>
            <div class="form-row-parse">
                <upload-template-file v-on:uploadComplite="updatePlots"></upload-template-file>
            </div>
        </div>
        <div class="form-row-parse" v-show="addContract">
            <div class="form-input-parse">
                <label for="contract-input">Шаблон договора</label>
                <select id="contract-input" v-model="idContract">
                    <option
                        v-for="(contract, key) in contracts"
                        :value="contract.ID"
                        :key="key"
                        >
                        {{ contract.NAME }}
                    </option>
                </select>
            </div>
            <div class="form-row-parse">
                <div v-show="info">{{ info }}</div>
            </div>
        </div>
        <div class="main_control_panel">
            <div class="data_select_element" v-show="showAddContracts">
                <span>
                    Шаблон договора "{{ selectContractName }}" будет добавлен к
                    {{ arraySelectPlots.length }}
                    участкам
                </span>
                <button @click="savePlotsContracts">Подтвердить</button>
                <button @click="unselectElements">Отменить</button>
            </div>
            <div
                class="data_select_element"
                v-show="arraySelectPlots.length > 0 && !addContract"
                >
                <button @click="unselectElements" class="close_select_data">X</button>
                <label>
                    Стоимость обслуживания:
                    <input v-model="plotDataMultiple.SERVICE_COST" type="text" />
                </label>
                <button @click="savePlotDataMultiple" class="add">
                    Сохранить
                </button>
                <pre>{{ arraySelectPlots | pretty }}</pre>
            </div>

            <yandex-map
                map-type="hybrid"
                :coords="coordsCenter"
                :zoom.sync="zoom"
                :controls="[]"
                @map-was-initialized.once="firstMapInit"
                >
                <ymap-marker
                    v-for="(item, index) in showVillageBound"
                    :coords="item.coordinates"
                    :marker-type="item.type"
                    :properties="{ id: item.id }"
                    :options="overlayVillage"
                    :marker-id="index"
                    v-bind:key="index + 'village'"
                    />
                <ymap-marker
                    v-for="(item, index) in plants"
                    :coords="item.coordinates"
                    :marker-type="item.type"
                    :options="item.options"
                    :properties="{ data: item, id: item.id, delete: 'N', type: 'plot', loaded: item.isLoaded }"
                    :marker-id="index"
                    :key="index + 'plant'"
                    />
            </yandex-map>
        </div>
        <form class="offcanvas offcanvas-end" tabindex="-1" data-bs-backdrop="false" @submit.prevent="savePlotData" ref="offcanvas">
            <header class="offcanvas-header">
                <h5 class="offcanvas-title">Настройки области</h5>
                <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"></button>
            </header>
            <div class="offcanvas-body">
                <table v-if="currentLoadedData.length">
                    <thead>
                        <td v-for="(cell, k) in headers"  :key="k">{{headers[k-1]?headers[k-1]:''}}</td>
                    </thead>
                    <tr  v-for="(data, key) in currentLoadedData" :key="key">
                        <td>
                            <popup-button v-for="(entity, ek) in entities" :key="ek" :button-text="ek" >
                                <div class="main">
                                    <div class="form-row">
                                        <div class="form-field" v-for="(fieldk, x) in entity" :key="x">
                                            <label>{{headers[fieldk]}}<input v-model="currentLoadedData[key][fieldk]" v-bind:class="{ error: currentErrors[key][fieldk]}"></label>
                                        </div>
                                        <div class="form-field">
                                            <button @click="downloadTemplateFaces">Выгрузить</button>
                                        </div>
                                    </div>
                                </div>
                            </popup-button></td>
                        <td v-for="(cell, k) in data"  :key="k"><input v-model="currentLoadedData[key][k]"  v-bind:class="{ error: currentErrors[key][k]}" v-show="parseInt(k) && k<headers.length"></td>
                    </tr>
                </table>

                <button @click="goToPlotDetail" type="button" class="btn btn-success btn-lg mb-5 w-100" v-if="currentPlots[0].ID">
                    Детальная информация
                </button>
                <fieldset class="mb-3">
                    <div class="mb-3 row">
                        <label for="plot-prefix" class="col-sm-4 col-form-label">Префикс</label>
                        <div class="col-sm-8">
                            <input v-model.trim="plotPrefix" type="text" class="form-control" id="plot-prefix">
                        </div>
                    </div>
                    <div class="mb-3 row flex-sm-nowrap">
                        <label for="min-plot-number" class="col-sm-4 col-form-label">Номера уч-в</label>
                        <div class="col-sm-8">
                            <div class="input-group">
                                <label for="min-plot-number" class="input-group-text">с</label>
                                <input v-model.number="minPlotsNumber" class="form-control" type="number" step="1" min="1" readonly id="min-plot-number">
                                <label for="max-plot-number" class="input-group-text" v-if="maxPlotsNumber !== null && maxPlotsNumber !== minPlotsNumber">по</label>
                                <input v-model.number="maxPlotsNumber" class="form-control" type="number" step="1" min="1" readonly id="max-plot-number" v-if="maxPlotsNumber !== null && maxPlotsNumber !== minPlotsNumber">
                            </div>
                        </div>
                    </div>

                    <button type="submit" class="btn btn-primary" :disabled="currentPlotsIds.length === 0">
                        Сохранить <span class="badge bg-info" v-if="currentPlotsIds.length > 0">{{ currentPlotsIds.length }}</span>
                    </button>
                </fieldset>
                <pre>{{ dataSelectElement | pretty }}</pre>
            </div>
        </form>
    </div>
</template>

<script>
    import config from "@/config";
    import { yandexMap, ymapMarker } from "vue-yandex-maps";

    export default {
        name: "AddVillageCoord",
        offcanvas: null,
        components: {yandexMap, ymapMarker},
        data() {
            return {
                info: null,
                map: false,
                contracts: false,
                idContract: null,
                addContract: false,
                paintListeners: false,
                selectionMode: false,
                selectionModeStyles: {
                    strokeColor: "#ff0000",
                    strokeOpacity: 0.6,
                    strokeWidth: 2,
                    fillColor: "#ff0000",
                    fillOpacity: 0.01
                },
                plantsData: {},
                landsChoseToEdit: [],
                landsDeleted: [],
                selectElementOb: false,
                fillColor: "#307c0d",
                fillColorChosed: "#7c0d16",
                fillColorSelect: "#b9b9b9",
                idVillage: null,
                idDistrict: null,
                idRegion: null,
                villages: [],
                districts: [],
                regions: [],
                plantsOnId: {},
                plants: [],
                entities: {},
                headers: [],
                zoom: 12,
                currentLoadedData: [],
                plotNumbers: false,
                currentErrors: [],
                plotNumbersRemoved: false,
                plotPrefix: null,
                currentPlots: [
                    {
                        ID: null,
                        NUMBER: null
                    }
                ],
                showVillageBound: [],
                url: config.backend_url,
                coordsCenter: [55.755819, 37.617644],
                overlayVillage: {
                    fillColor: "#7c270d",
                    strokeColor: "#fcfcfc",
                    fillOpacity: 0.5,
                    strokeWidth: 1
                },
                overlayPlant: {
                    fillColor: "#307c0d",
                    strokeColor: "#fcfcfc",
                    fillOpacity: 0.5,
                    strokeWidth: 1
                },
                buttonSelectMode: false,
                arraySelectPlots: [],
                plotDataMultiple: {
                    SERVICE_COST: null
                }
            };
        },
        computed: {
            selectContractName: function () {
                return this.idContract ? this.contracts[this.idContract].NAME : "";
            },
            dataSelectElement: function () {
                return this.selectElementOb
                        ? this.selectElementOb.properties.get("data")
                        : false;
            },
            showAddContracts: function () {
                return this.arraySelectPlots.length > 0 && this.addContract;
            },
            currentPlotsIds: function ()
            {
                let ids = [];

                this.currentPlots.forEach((plot) => {

                    if (plot['ID'] && !ids.includes(plot['ID'])) {
                        ids.push(plot['ID']);
                    }
                });

                return ids;
            },
            minPlotsNumber: function()
            {
                return this.currentPlots[0].NUMBER;
            },
            maxPlotsNumber: function()
            {
                let index = this.currentPlots.length - 1;

                return this.currentPlots[index].NUMBER;
            }
        },
        watch: {
            zoom: function (newZoom) {
                let maxZoom = 15;
                if (newZoom < maxZoom && !this.plotNumbersRemoved) {
                    this.plotNumbersRemoved = true;
                    if (this.plotNumbers)
                        this.plotNumbers.removeFromMap(this.map);
                } else if (newZoom >= maxZoom && this.plotNumbersRemoved) {
                    this.plotNumbersRemoved = false;
                    this.plotNumbers.addToMap(this.map);
                }
            },
            currentPlotsIds: function (ids)
            {
                window.ymaps.geoQuery(this.map.geoObjects)
                        .search('properties.type = "plot"')
                        .search("properties.select != 'Y'")
                        .search("properties.loaded != 'Y'")
                        .each((element) => {

                            if (ids.includes(element.properties.get('id'))) {
                                element.options.set("fillColor", this.fillColorSelect);
                            } else {
                                element.options.set("fillColor", this.fillColor);
                            }
                        });

                if (ids.length) {
                    this.$options.offcanvas.show();
                }
            }
        },
        methods: {
            goToPlotDetail: function () {
                this.$router.push({
                    name: "DetailPlot",
                    params: {
                        id: this.currentPlots[0]['ID']
                    }
                });
            },
            clickPolygon: function (e)
            {
                this.selectElementOb = e.get('target');

                let id = this.selectElementOb.properties.get("id");
                let ctrlKey = e.originalEvent.domEvent.originalEvent.ctrlKey;
                let data = this.selectElementOb.properties.get("data");
                let dataNumber = data['data']['NUMBER'] ? data['data']['NUMBER'] : null;
                let index = this.currentPlotsIds.indexOf(id);
                this.currentLoadedData = data.loadedData || [];
                this.currentErrors = data.errors || [];

                if (ctrlKey && this.minPlotsNumber !== null) {
                    dataNumber = this.maxPlotsNumber + 1;
                }

                if (dataNumber)
                {
                    let matches = typeof(dataNumber) === 'string' ? dataNumber.match(/^(.*)(\d+)$/) : null;

                    if (Array.isArray(matches))
                    {
                        dataNumber = matches.pop();

                        if (this.minPlotsNumber === null && matches.length === 2) {
                            this.plotPrefix = matches[1].replace(/-$/, ''); //Устанавливаем префикс только по клику на первом элементе
                        }
                    }

                    if (index === 0) { //убираем выделение полностью
                        this.currentPlots = [{ID: null, NUMBER: null}];
                    } else if (ctrlKey && index === -1) { //добавляем новую область
                        this.currentPlots.push({ID: id, NUMBER: parseInt(dataNumber)});
                    } else if (ctrlKey && index > 0) { //снимаем конкретную область
                        this.currentPlots.splice(index, 1);
                    } else { //Начинаем выбор по новой
                        this.currentPlots = [{ID: id, NUMBER: parseInt(dataNumber)}];
                    }
                }
            },
            closeSelectData() {
                this.selectElementOb.properties.set("selected", "N");
                this.selectElementOb.options.set("fillColor", this.fillColor);
                this.selectElementOb = false;
            },
            unselectElements() {
                let objects = window.ymaps.geoQuery(this.map.geoObjects);
                let otherObjects = objects
                        .search("properties.type = 'plot'")
                        .search("properties.select = 'Y'");
                otherObjects.setOptions("fillColor", this.fillColor);
                otherObjects.setProperties("select", "N");
                this.arraySelectPlots = [];
            },
            firstMapInit: function (map)
            {
                this.$options.offcanvas = new bootstrap.Offcanvas(this.$refs.offcanvas);

                this.map = map;
                if (this.$route.query.addContracts) {
                    this.firstShowVillage();
                    this.getContracts();
                    this.addContract = true;
                } else {
                    this.getRegions();
                    this.idRegion = this.$route.query.region;
                    if (this.idRegion)
                        this.getDistricts();
                    this.idDistrict = this.$route.query.district;
                    if (this.idDistrict)
                        this.getVillages();
                    this.firstShowVillage();
                }
            },
            firstShowVillage: function () {
                setTimeout(() => {
                    this.addMapControls();
                    this.idVillage = this.$route.query.village;
                    if (this.idVillage)
                        this.showVillage();
                }, 500);
            },
            getContracts: function () {
                let data = {
                    url: this.url + "agreementtypelist/get/",
                    data: {},
                    method: "POST"
                };
                this.$store.dispatch("query/sendRequest", data).then(response => {
                    let data = response.data;
                    if (!data.error) {
                        this.contracts = data;
                    }
                });
            },
            getRegions: function () {
                let self = this;
                let data = {
                    url: self.url + "regions/get/",
                    data: {},
                    method: "POST"
                };
                this.$store.dispatch("query/sendRequest", data).then(function (response) {
                    let data = response.data;
                    if (!data.error) {
                        self.regions = data;
                    }
                });
            },
            getDistricts: function () {
                let self = this;
                let data = {
                    url: self.url + "districts/get/",
                    filter: {REGION: self.idRegion},
                    method: "POST"
                };
                this.$store.dispatch("query/sendRequest", data).then(function (response) {
                    let data = response.data;
                    if (!data.error) {
                        self.districts = data;
                    }
                });
            },
            getVillages: function () {
                let self = this;
                let data = {
                    url: self.url + "villages/get/",
                    filter: {DISTRICT: self.idDistrict},
                    method: "POST"
                };
                this.plants = [];
                this.$store
                        .dispatch("query/sendRequest", data)
                        .then(function (response) {
                            let data = response.data;
                            if (!data.error) {
                                self.villages = data;
                                let elementsData = [];
                                for (const [key, value] of Object.entries(data)) {
                                    let coord = JSON.parse(value.GEO_COORD);
                                    let valueCoord = {};
                                    coord.forEach(function (val) {
                                        valueCoord.name = value.NAME;
                                        valueCoord.type = val.type;
                                        valueCoord.id = parseInt(key);
                                        valueCoord.coordinates = val.coordinates;
                                        elementsData.push(valueCoord);
                                    });
                                }
                                self.showVillageBound = elementsData;
                            }
                        })
                        .then(function () {
                            setTimeout(function () {
                                self.map.setBounds(self.map.geoObjects.getBounds(), {
                                    checkZoomRange: true,
                                    duration: 1
                                });
                            }, 1);
                        });
            },
            addQueries: function () {
                this.$router.push({
                    query: {
                        village: this.idVillage,
                        district: this.idDistrict,
                        region: this.idRegion
                    }
                });
            },
            getPolygonCentroid(arr) {
                var x = arr.map(function (a) {
                    return a[0];
                });
                var y = arr.map(function (a) {
                    return a[1];
                });
                var minX = Math.min.apply(null, x);
                var maxX = Math.max.apply(null, x);
                var minY = Math.min.apply(null, y);
                var maxY = Math.max.apply(null, y);
                return [(minX + maxX) / 2, (minY + maxY) / 2];
            },
            setLandsNumber() {
                //if (this.plotNumbers) this.plotNumbers.removeFromMap(this.map);
                let resultArr = {
                    type: "FeatureCollection",
                    features: []
                };
                let self = this;
                this.plants.forEach(function (value) {
                    let coords = value.coordinates;
                    let center = self.getPolygonCentroid(coords[0]);
                    let number = value.data.NUMBER;
                    let content = window.ymaps.templateLayoutFactory.createClass(
                            '<div class="numbers" style="color:#ffffff;font-size:10px;">' +
                            number +
                            "</div>"
                            );
                    let result = {
                        type: "Feature",
                        geometry: {
                            type: "Point",
                            coordinates: center
                        },
                        properties: {
                            ID: value.id,
                            type: "landNumber"
                        },
                        options: {
                            iconLayout: "default#imageWithContent",
                            iconImageHref: "",
                            hasBalloon: false,
                            hasHint: false,
                            zIndex: -9,
                            zIndexHover: -9,
                            iconImageSize: [0, 0],
                            iconOffset: [-number.length * 2.5, -5],
                            iconContentLayout: content
                        }
                    };
                    if (number)
                        resultArr.features.push(result);
                });
                this.plotNumbers = window.ymaps.geoQuery(resultArr).addToMap(this.map);
            },
            changeVillage: function () {
                this.addQueries();
                this.showVillage();
            },
            showVillage: function (callback) {
                let self = this;
                this.showVillageBound = [];
                this.plants = [];

                let data = {
                    url: self.url + "plots/get/",
                    filter: {VILLAGE: this.idVillage},
                    method: "POST"
                };
                this.$store
                        .dispatch("query/sendRequest", data)
                        .then(function (response) {
                            let data = response.data;
                            if (!data.error) {

                                let elementsData = {};
                                self.plantsOnId = data;
                                for (const [key, value] of Object.entries(data)) {
                                   
                                    elementsData[value.KADASTR] = {
                                        name: value.KADASTR,
                                        type: "Polygon",
                                        id: parseInt(key),
                                        coordinates: [JSON.parse(value.COORDINATES)],
                                        data: value,
                                        options: JSON.parse(JSON.stringify(self.overlayPlant))
                                    };
                                    data[key].number_of_fields = 1;
                                }
                                self.plants = Object.values(elementsData);
                                self.plantsData = data;
                                if (callback) {
                                    callback();
                                }
                                self.setLandsNumber();
                                self.paintOnMap();
                            }
                        })
                        .then(function () {
                            setTimeout(function () {
                                self.setEventsToPlots();
                                self.map.setBounds(self.map.geoObjects.getBounds());
                            }, 100);
                        });
            },
            addMapControls() {
                let buttonSelectMode = new window.ymaps.control.Button({
                    data: {content: "Полигон"},
                    options: {maxWidth: 150}
                });
                buttonSelectMode.events
                        .add("select", function (e) {
                            let thisButton = e.get("target");
                            thisButton.data.set("content", "Линия");
                        })
                        .add("deselect", function (e) {
                            let thisButton = e.get("target");
                            thisButton.data.set("content", "Полигон");
                        });

                this.map.controls.add(buttonSelectMode);
                this.buttonSelectMode = buttonSelectMode;

                let buttonPaintMode = new window.ymaps.control.Button({
                    data: {content: "Режим выделения"},
                    options: {maxWidth: 150}
                });
                buttonPaintMode.events
                        .add("select", this.paintProcess)
                        .add("deselect", this.paintProcessClose);

                this.map.controls.add(buttonPaintMode);
            },
            savePlotData()
            {
                let data = {
                    url: this.url + "plots/update-multi/",
                    method: "POST",
                    data: this.currentPlots.map((plot) => {

                        if (this.plotPrefix) {
                            plot.NUMBER = this.plotPrefix + '-' + plot.NUMBER;
                        }

                        return plot;
                    })
                };

                this.$store.dispatch("query/sendRequest", data).then(() => {
                    this.closeSelectData();
                    this.showVillage();
                });
            },
            savePlotsContracts() {
                if (this.arraySelectPlots.length > 0) {
                    let data = {
                        url: this.url + "documents/add-plots-document/",
                        method: "POST",
                        data: {
                            AGREEMENT_TYPE: this.idContract,
                            VILLAGE: this.idVillage,
                            PLOTS: this.arraySelectPlots
                        }
                    };
                    this.$store.dispatch("query/sendRequest", data).then(request => {
                        console.log(request.data);
                        if (!data.error)
                            this.unselectElements();
                    });
                }
            },
            savePlotDataMultiple() {
                let self = this;
                let arrayData = [];
                if (this.arraySelectPlots.length > 0) {
                    this.arraySelectPlots.forEach(function (value) {
                        arrayData.push({
                            ID: value,
                            SERVICE_COST: self.plotDataMultiple.SERVICE_COST
                        });
                    });
                    let data = {
                        url: self.url + "plots/update-multi/",
                        method: "POST",
                        data: arrayData
                    };
                    this.$store.dispatch("query/sendRequest", data).then(function () {
                        if (!data.error) {
                            self.unselectElements();
                        }
                    });
                }
            },
            paintOnMap() {
                window.ymaps.modules.define(
                        "ext.paintOnMap",
                        ["meta", "util.extend", "pane.EventsPane", "Event"],
                        function (provide, meta, extend, EventsPane, Event) {
                            "use strict";

                            // zIndex пейна событий карты по умолчанию равен 500.
                            // Подробней в документации: https://tech.yandex.ru/maps/doc/jsapi/2.1/ref/reference/map.pane.Manager-docpage/
                            var EVENTS_PANE_ZINDEX = 500;

                            var DEFAULT_UNWANTED_BEHAVIORS = ["drag", "scrollZoom"];
                            var DEFAULT_STYLE = {
                                strokeColor: "#0000ff",
                                strokeWidth: 1,
                                strokeOpacity: 1
                            };
                            var DEFAULT_TOLERANCE = 16;

                            var badFinishPaintingCall = function () {
                                throw new Error(
                                        "(ymaps.ext.paintOnMap) некорректный вызов PaintingProcess#finishPaintingAt. Рисование уже завершено."
                                        );
                            };

                            /**
                             * @interface ymaps.ext.paintOnMap.PaintingProcess
                             */

                            /**
                             * Отключает режим рисования.
                             * @function
                             * @name ymaps.ext.paintOnMap.PaintingProcess#finishPaintingAt
                             * @param {Number[]|ymaps.Event} [positionOrEvent] Координаты точки, в которой рисование должно закончиться.
                             * Координаты задаются в пикселях относительно верхнего левого угла карты.
                             * @return {Number[]} Координаты.
                             */

                            /**
                             * Включает режим рисования.
                             * @name ymaps.ext.paintOnMap
                             * @param {ymaps.Map} map
                             * @param {Number[]|ymaps.Event} [positionOrEvent] Координаты точки, в которой рисование должно закончиться.
                             * Координаты задаются в пикселях относительно верхнего левого угла карты.
                             * @param {Object} [config]
                             * @param {String[]|null} [config.unwantedBehaviors] Список поведений карты, которые должны быть выключены во время
                             * рисования. Перетаскивание карты и её масштабирование колесом мыши выключены по умолчанию.
                             * @param {Object} [config.style] Стили такие же, как в ymaps.Polygon или ymaps.Polyline.
                             * @param {String} [config.style.strokeColor='#0000ff'] Цвет линии или обводки.
                             * @param {Number} [config.style.strokeWidth=1] Толщина линии или обводки.
                             * @param {Number} [config.style.strokeOpacity=1] Прозрачность линии или обводки.
                             * @param {Number} [config.tolerance=16] Уровень упрощения координат в пикселях.
                             * @returns {ymaps.ext.paintOnMap.PaintingProcess} Процесс рисования.
                             */
                            function paintOnMap(map, positionOrEvent, config) {
                                config = config || {};
                                var style = extend(DEFAULT_STYLE, config.style || {});

                                var unwantedBehaviors =
                                        config.unwantedBehaviors === undefined
                                        ? DEFAULT_UNWANTED_BEHAVIORS
                                        : config.unwantedBehaviors;

                                var pane = new EventsPane(map, {
                                    css: {position: "absolute", width: "100%", height: "100%"},
                                    zIndex: EVENTS_PANE_ZINDEX + 50,
                                    transparent: true
                                });

                                map.panes.append("ext-paint-on-map", pane);

                                if (unwantedBehaviors) {
                                    map.behaviors.disable(unwantedBehaviors);
                                }

                                // Создаём canvas-элемент.
                                var canvas = document.createElement("canvas");
                                var ctx2d = canvas.getContext("2d");
                                var rect = map.container.getParentElement().getBoundingClientRect();
                                canvas.width = rect.width;
                                canvas.height = rect.height;

                                ctx2d.globalAlpha = style.strokeOpacity;
                                ctx2d.strokeStyle = style.strokeColor;
                                ctx2d.lineWidth = style.strokeWidth;

                                canvas.style.width = "100%";
                                canvas.style.height = "100%";

                                pane.getElement().appendChild(canvas);

                                var firstPosition = positionOrEvent
                                        ? toPosition(positionOrEvent)
                                        : null;
                                var coordinates = firstPosition ? [firstPosition] : [];

                                var bounds = map.getBounds();
                                var latDiff = bounds[1][0] - bounds[0][0];
                                var lonDiff = bounds[1][1] - bounds[0][1];

                                canvas.onmousemove = function (e) {
                                    coordinates.push([e.offsetX, e.offsetY]);

                                    ctx2d.clearRect(0, 0, canvas.width, canvas.height);
                                    ctx2d.beginPath();

                                    ctx2d.moveTo(coordinates[0][0], coordinates[0][1]);
                                    for (var i = 1; i < coordinates.length; i++) {
                                        ctx2d.lineTo(coordinates[i][0], coordinates[i][1]);
                                    }

                                    ctx2d.stroke();
                                }.bind(this);

                                // Создаём косвенное обращение, чтобы не сдерживать сборщик мусора.
                                var paintingProcess = {
                                    finishPaintingAt: function (positionOrEvent) {
                                        paintingProcess.finishPaintingAt = badFinishPaintingCall;

                                        // Получаем координаты, прежде чем удалить пейн.
                                        if (positionOrEvent) {
                                            coordinates.push(toPosition(positionOrEvent));
                                        }

                                        map.panes.remove(pane);
                                        if (unwantedBehaviors) {
                                            map.behaviors.enable(unwantedBehaviors);
                                        }

                                        var tolerance =
                                                config.tolerance === undefined
                                                ? DEFAULT_TOLERANCE
                                                : Number(config.tolerance);
                                        if (tolerance) {
                                            coordinates = simplify(coordinates, tolerance);
                                        }
                                        // Преобразовываем координаты canvas-элемента в геодезические координаты.
                                        return coordinates.map(function (x) {
                                            var lon = bounds[0][1] + (x[0] / canvas.width) * lonDiff;
                                            var lat = bounds[0][0] + (1 - x[1] / canvas.height) * latDiff;

                                            return meta.coordinatesOrder === "latlong"
                                                    ? [lat, lon]
                                                    : [lon, lat];
                                        });
                                    }
                                };

                                return paintingProcess;
                            }

                            function toPosition(positionOrEvent) {
                                return positionOrEvent instanceof Event
                                        ? [positionOrEvent.get("offsetX"), positionOrEvent.get("offsetY")]
                                        : positionOrEvent;
                            }

                            function simplify(coordinates, tolerance) {
                                var toleranceSquared = tolerance * tolerance;
                                var simplified = [coordinates[0]];

                                var prev = coordinates[0];
                                for (var i = 1; i < coordinates.length; i++) {
                                    var curr = coordinates[i];
                                    if (
                                            Math.pow(prev[0] - curr[0], 2) +
                                            Math.pow(prev[1] - curr[1], 2) >
                                            toleranceSquared
                                            ) {
                                        simplified.push(curr);
                                        prev = curr;
                                    }
                                }

                                return simplified;
                            }

                            provide(paintOnMap);
                        }
                );
            },
            paintProcessClose() {
                this.selectionMode = false;
                this.paintListeners.removeAll();
                this.unselectElements();
            },
            paintMouseUp(e) {
                let self = this;
                if (this.paintProcess) {
                    let objects = window.ymaps.geoQuery(self.map.geoObjects);
                    let coordinates = this.paintProcess.finishPaintingAt(e);
                    this.paintProcess = null;

                    let geoObject = !self.buttonSelectMode.isSelected()
                            ? new window.ymaps.Polygon(
                                    [coordinates],
                                    {},
                                    self.selectionModeStyles
                                    )
                            : new window.ymaps.Polyline(
                                    coordinates,
                                    {},
                                    self.selectionModeStyles
                                    );

                    self.map.geoObjects.add(geoObject);

                    let objectsInside = objects
                            .searchIntersect(geoObject)
                            .search('properties.type="plot"')
                            .search('properties.select!="Y"');

                    objectsInside.each(function (plot) {
                        let id = plot.properties.get("id");
                        self.arraySelectPlots.push(id);
                        //console.log(self.plantsOnId[id]);
                    });

                    objectsInside.setOptions("fillColor", "#416bff");
                    objectsInside.setProperties("select", "Y");

                    self.map.geoObjects.remove(geoObject);
                }
            },
            paintMouseDown(e) {
                let self = this;
                if (e.get("altKey")) {
                    this.paintProcess = window.ymaps.ext.paintOnMap(self.map, e, {
                        style: self.selectionModeStyles
                    });
                }
            },
            paintProcess() {
                let self = this;
                this.selectionMode = true;
                window.ymaps
                        .ready(["ext.paintOnMap"])
                        .then(function () {
                            self.paintListeners = self.map.events
                                    .group()
                                    .add("mousedown", self.paintMouseDown)
                                    .add("mouseup", self.paintMouseUp);
                        })
                        .catch(console.error);
            },
            setEventsToPlots() {
                let objects = window.ymaps.geoQuery(this.map.geoObjects);
                let plots = objects.search('properties.type="plot"');

                plots.addEvents("click", this.clickPolygon);
                plots.addEvents("contextmenu", this.removeSingleSelect);
            },
            removeSingleSelect(e) {
                if (this.selectionMode) {
                    let element = e.get("target");
                    let id = element.properties.get("id");
                    let index = this.arraySelectPlots.indexOf(id);
                    if (index > -1) {
                        this.arraySelectPlots.splice(index, 1);
                    }
                    element.options.set("fillColor", this.fillColor);
                }
            },
            forceFileDownload(response, file_name) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", file_name + ".xls"); //or any other extension
                document.body.appendChild(link);
                link.click();
            },
            downloadTemplateContracts() {
                let self = this;
                this.$store
                        .dispatch("query/sendRequest", {
                            url: self.url + "plots/load-template-contracts/",
                            responseType: "arraybuffer",
                            method: "POST",
                            data: {
                                VILLAGE: self.idVillage
                            }
                        })
                        .then(response => {
                            this.forceFileDownload(response, 'contracts');
                        })
                        .catch(() => console.log("error occured"));
            },
            downloadTemplateFaces() {
                let self = this;
                this.$store
                        .dispatch("query/sendRequest", {
                            url: self.url + "plots/load-template-faces/",
                            responseType: "arraybuffer",
                            method: "POST",
                            data: {
                                VILLAGE: self.idVillage,
                                plants: self.plantsData
                            }
                        })
                        .then(response => {
                            this.forceFileDownload(response, 'faces');
                        })
                        .catch(() => console.log("error occured"));
            },
            updatePlots(response) {
                var data = response.data;
                this.idVillage = data.village;
                var component = this;
                component.entities = data.entities;
                component.headers = data.headers;
                var callback = function () {
                    data.rows.forEach(function (currentValue, index, array) {
                        if (currentValue.have_data && !currentValue.existed) {
                            component.plants.forEach(function (plant) {
                                plant.loadedData = plant.loadedData || [];
                                plant.errors = plant.errors || [];
                                if (plant.id == currentValue[2]) {
                                    plant.options.fillColor = "#2e426b";
                                    plant.isLoaded = 'Y';
                                    plant.loadedData.push(currentValue);
                                    plant.errors.push(data.errors[index]);
                                }
                            });
                        }
                    });
                }
                this.showVillage(callback);
            }
        },
        filters: {
            pretty: function (value) {
                return JSON.stringify(value, null, 2);
            }
        }
    };
</script>
